import {ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Subject, Subscription} from 'rxjs';
import {FormControl, NgForm} from '@angular/forms';
import {TreeModel} from 'src/app/core/models/tree-model';
import {DocumentService} from 'src/app/core/services/document.service';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {NzTreeSelectComponent} from "ng-zorro-antd";
import {CommonService} from "../../../../../../core/services/common.service";
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-select-document-type',
  templateUrl: './select-document-type.component.html',
  styleUrls: ['./select-document-type.component.scss']
})
export class SelectDocumentTypeComponent implements OnInit, OnDestroy {
  @ViewChild(NzTreeSelectComponent, {static: false}) nzTreeSelectComponent: NzTreeSelectComponent;
  @ViewChild('inputElement', {static: false}) inputElement: ElementRef;


  filterTimeout: any;
  observable: any;
  myControl = new FormControl();
  checkFocus = false;
  searchCtrl: FormControl = new FormControl();
  checkDrop = false;

  displayFn(option: any): string {
    return option ? option.title : '';
  }

  selectedOption = 1;
  myForm: any;
  subscription: Subscription;

  constructor(
    private elementRef: ElementRef,
    public dialogRef: MatDialogRef<SelectDocumentTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialog: MatDialog,
    private documentService: DocumentService,
    public commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private documentTypeService: DocumentTypeService,
    private toastr: ToastrService
  ) {
  }

  checkEscKey = false;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  private _onDestroy = new Subject<void>();
  dataTree: Array<TreeModel> = [];
  dataTree1: Array<TreeModel> = [];
  dataSelect: any = [];
  documentTypeEnterprise: any;
  documentTypeEnterpriseId = '';
  getNodeTitle = (node: any) => node.title.toLowerCase();



  ngOnInit() {
    this.documentService.getDocumentsType(this.dataDialog.isDocumentMoha!).subscribe(rs => {
      this.documentTypeEnterprise = rs.data;
      if (rs == null || rs.data == null) {
        return 0;
      }
      // Convert Json data to Array<TreeModel>
      for (const node of rs.data) {
        if (node.parentId === undefined) {
          const parentModel = new TreeModel();
          parentModel.title = node.code + " - " + node.name;
          parentModel.key = node.id;
          parentModel.description = node.description;
          parentModel.isLeaf = true;
          // if (!node.hasChildren) {
          //   parentModel.isLeaf = true;
          // }
          this.dataTree.push(parentModel);
        }
      }
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.dataTree.length; i++) {
        for (const child of rs.data) {
          if (child.parentId !== undefined && this.dataTree[i].key === child.parentId) {
            const childModel = new TreeModel();
            childModel.title = child.code + " - " + child.name;
            childModel.key = child.id;
            childModel.isLeaf = true;
            childModel.parentId = child.parentId;
            childModel.code = child.code;
            childModel.description = child.description;
            this.dataTree[i].isLeaf = false;
            this.dataTree[i].children.push(childModel);
          }
        }
      }
      this.dataSelect = this.dataTree;
    });

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  changeData() {
    this.dataSelect = this.dataTree;
  }

  FilterData(event: any) {
    this.dataSelect = this.dataTree.filter(item =>
      (item.title && item.title.toLowerCase().includes(event.target.value.toLowerCase())) ||
      (typeof item.code === 'string' && item.code.toLowerCase().includes(event.target.value.toLowerCase()))
    );
  }

  /**
   * Close pop-up
   */
  cancel() {
    if (!this.documentTypeEnterprise || this.documentTypeEnterprise.id == '') {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }
  clear() {
    this.documentTypeEnterpriseId = '';
    this.myControl.setValue('');
    this.dataSelect = this.dataTree;
  }

  selectDocumentType() {
    if (this.documentTypeEnterpriseId != '' || this.documentTypeEnterpriseId != null) {
      this.dialogRef.close(
        {
          data: { documentTypeEnterprise: this.documentTypeEnterprise.find( data => data.id == this.documentTypeEnterpriseId),
            onChange: true, valueSelect: 0
          }}
      );
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
  }

  onSelectionChange(event: any) {
    console.log(this.selectedOption.toString());
    this.documentTypeService.checkPermissionServiceType(this.selectedOption.toString()).subscribe((rs) => {
      if(rs.success) {
        this.documentTypeEnterpriseId = this.selectedOption.toString();
      } else {
        this.documentTypeEnterpriseId = '';
        this.toastr.error(rs.message);
      }
      console.log(rs);
    });
  }

}
